import { Box, Typography } from "@mui/material";
import { Study } from "../../models";
import { EditStudyContext } from "../useEditStudyContext";

import EditAudioFileUpload from "./EditAudioFileUpload";

interface EditStudyAudioFileProps {
  study: Study;
  edit_context: EditStudyContext;
}
export default function EditStudyAudioFiles({ study, edit_context }: EditStudyAudioFileProps) {
  return (
    <Box>
      <Typography variant="h6" sx={{ fontSize: "12px", fontWeight: "400" }}>
        Audio Transcripts
      </Typography>
      {(edit_context.study?.audio_assignments ?? []).map((assignment, i) => {
        const fileEditState = edit_context.getAudioFile(assignment.audio_file_id);
        return <EditAudioFileUpload key={i} study={study} edit_context={edit_context} fileEditState={fileEditState!} />;
      })}
    </Box>
  );
}
